/**
 * Tenant Types
 *
 * These types mirror the backend tenant settings and are used
 * to control UI mode throughout the app.
 *
 * Feature access (saia_recruiting, saia_sales, motive, lead) is now
 * derived from licenses via GET /tenants/current/features, NOT from
 * tenant settings.
 */

/**
 * UI Mode determines the default experience for tenants
 * - 'simplified': AI Chat landing page, Co-Pilots only, streamlined UI
 * - 'full': Feature Overview landing, all features visible based on licenses
 */
export type TenantUIMode = 'simplified' | 'full';

/**
 * Complete tenant settings from the API
 */
export interface TenantSettings {
  defaultLanguage: 'en' | 'de';
  defaultTimezone: string;
  uiMode: TenantUIMode;
  /** Expert mode toggle in campaigns (allows switching from chat to manual mode) */
  expertCampaignBuilder: boolean;
}

/**
 * Default tenant settings
 */
export const DEFAULT_TENANT_SETTINGS: TenantSettings = {
  defaultLanguage: 'en',
  defaultTimezone: 'Europe/Berlin',
  uiMode: 'simplified',
  expertCampaignBuilder: true,
};
